<template>
  <v-toolbar dense :color="$store.state.sysBackgroundColor">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon @click="ejecutarAccion('Cerrar')" v-on="on">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </template>
      <span>Volver</span>
    </v-tooltip>
    <v-spacer></v-spacer>
    <v-toolbar-title class="overline">{{ titulo }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          color="primary"
          @click="ejecutarAccion('Ejecutar')"
          v-on="on"
        >
          <v-icon>check</v-icon>
        </v-btn>
      </template>
      <span>Ejecutar</span>
    </v-tooltip>
    <slot></slot>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-if="!sinAccionReiniciar"
          @click="ejecutarAccion('Inicializar')"
          v-on="on"
        >
          <v-icon>undo</v-icon>
        </v-btn>
      </template>
      <span>Reiniciar</span>
    </v-tooltip>
  </v-toolbar>
</template>

<script>
export default {
  name: "EncabezadoProceso",
  props: {
    titulo: String,
    accion: String,
    sinAccionReiniciar: Boolean
  },
  data() {
    return {
      activo: false
    };
  },
  methods: {
    ejecutarAccion(accion) {
      if (accion == "Cerrar") this.$router.go(-1);
      else {
        this.$emit("ejecutarAccion", accion);
      }
    }
  }
};
</script>
